export const SETTING = [
  "Classroom",
  "Community Setting",
  "Dining Area",
  "Gym / Fitness Area",
  "Hallway / Common Area",
  "Hub / Central Facility",
  "Non-Classroom Building Area",
  "Office",
  "Outdoors",
  "Residential / Living Area",
  "Sensory Room / Sensory Gym",
  "Telehealth / Virtual",
  "Therapy Room",
  "Transition Area",
  "Vehicle / Transportation",
  "Other"
];

export const GROUP_SIZE = [
  'Individual',
  'Group of 1',
  'Group of 2',
  'Group of 3',
  'Group of 4',
  'Group of 5',
  'Other',
];

export const GROUP_TYPE = [
  'Psychoeducational',
  'Social Skills',
  'Socio-Sexual Skills',
  'Process',
  'Self-Care',
  'LGBTQ+',
  'Confidence & Care',
  'Summer Stories',
  'Other',
]; // the display on their end is inconsistent in terms of capitalization, so we need to make sure to match the capitalization of the display, but looks better when we capitalize it here

export const ABSENT_REASON = [
  'Student absent',
  'Student not available',
  'Therapist absent',
  'Therapist not available',
  'Delay',
  'School closed - Snow day',
  'Holiday',
  'School break',
  'Other',
];

export const SESSION_TYPES = [
  "BCBA",
  "Occupational Therapist",
  "Speech and Language Pathologist",
  "Special Education Teacher",
  "Psychologist",
  "School Psychologist",
  "Physical Therapist",
  "Mental Health Clinician",
  "Behavioral role",
  "RBT",
  "Residential Staff",
  "Nurse",
  "Classroom Aide",
  "Art Therapist",
  "Tutor",
  "Other",
];

export const SESSION_LENGTH = [
  '5 Mins (0.33 units)',
  '8 Mins (0.5 units)',
  '15 Mins (1 unit)',
  '20 Mins (1.33 units)',
  '25 Mins (1.67 units)',
  '30 Mins (2 units)',
  '40 Mins (2.67 units)',
  '45 Mins (3 units)',
  '1 Hr (4 units)',
  '1 Hr 15 Mins (5 units)',
  '1 Hr 30 Mins (6 units)',
  '1 Hr 45 Mins (7 units)',
  '2 Hrs (8 units)',
  '2 Hrs 15 Mins (9 units)',
  '2 Hrs 30 Mins (10 units)',
  '2 Hrs 45 Mins (11 units)',
  '3 Hrs (12 units)',
  '3 Hrs 15 Mins (13 units)',
  '3 Hrs 30 Mins (14 units)',
  '3 Hrs 45 Mins (15 units)',
  '4 Hrs (16 units)',
  'Other',
];

// @deprecated Use getCPTCodesBySubrole() instead to get role-specific CPT codes
// This constant only contains OT codes and is kept for backward compatibility
export const CPT_CODES = [
  { code: 97165, label: 'Occupational therapy evaluation, low complexity' },
  {
    code: 97166,
    label: 'Occupational therapy evaluation, moderate complexity',
  },
  { code: 97167, label: 'Occupational therapy evaluation, high complexity' },
  {
    code: 97168,
    label: 'Occupational therapy re-evaluation (for ongoing plan of care)',
  },

  {
    code: 97530,
    label:
      'Therapeutic activities, direct (one-on-one) patient contact, each 15 minutes',
  },
  {
    code: 97533,
    label:
      'Sensory integrative techniques to enhance sensory processing, each 15 minutes',
  },
  { code: 97535, label: 'Self-care/home management training, each 15 minutes' },
  {
    code: 97537,
    label: 'Community/work reintegration training, each 15 minutes',
  },
  {
    code: 97150,
    label: 'Therapeutic procedure(s), group (2 or more), untimed',
  },
  {
    code: 97112,
    label:
      'Neuromuscular reeducation of movement, balance, coordination, kinesthetic sense, posture, and/or proprioception',
  },
  { code: 97116, label: 'Gait training (includes stair climbing)' },
  {
    code: 97124,
    label: 'Massage, including effleurage, petrissage, and/or tapotement',
  },
  { code: 97542, label: 'Wheelchair management, each 15 minutes' },
  {
    code: 97550,
    label:
      'Caregiver training in strategies and techniques, face to face; initial 30 minutes',
  },

  {
    code: 97750,
    label: 'Physical performance test or measurement, each 15 minutes',
  },
  {
    code: 97755,
    label:
      'Assistive technology assessment, direct one-on-one, with written report, each 15 minutes',
  },
];

// Re-export getCPTCodesBySubrole for convenience
export { getCPTCodesBySubrole } from '../../../constants/CPTCodes';
